/* import __COLOCATED_TEMPLATE__ from './invalid.hbs'; */
import { service } from '@ember/service';
import Component from '@glimmer/component';

export default class SignInTokenStatesInvalid extends Component {
  @service signIn;

  get shouldShowAuthError() {
    return this.args.showAuthError && this.signIn.lastError !== 'invalid';
  }
}
